// All announcement media (cover image, benefit/announcement icons, and
// rich-text content images) upload to this bucket — the same one the rest of
// the announcement flow uses (the long-standing 'annoucement-images' spelling).
export const ANNOUNCEMENT_BUCKET = 'annoucement-images';
